import { PRODUCT_TEMPLATES } from '../productTemplates'

export const productAccessorIsRxOrOtxTemplate = (
  productTemplate: PRODUCT_TEMPLATES,
): boolean =>
  [PRODUCT_TEMPLATES.OTX, PRODUCT_TEMPLATES.RX].includes(productTemplate)
